import { render, staticRenderFns } from "./PrinterItem.vue?vue&type=template&id=61f6981e&scoped=true"
import script from "./PrinterItem.vue?vue&type=script&lang=js"
export * from "./PrinterItem.vue?vue&type=script&lang=js"
import style0 from "./PrinterItem.vue?vue&type=style&index=0&id=61f6981e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6981e",
  null
  
)

export default component.exports